module.exports = __webpack_public_path__ + "static/lezaki-basen_thumb-29cd8e547f44af075aebba0668f52b43.jpg";